var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46722 3.34952C6.33005 3.34952 6.19849 3.4053 6.10149 3.5046C6.00449 3.60389 5.95 3.73856 5.95 3.87898V4.43923C6.37459 4.51368 6.76962 4.72093 7.07829 5.0369C7.47138 5.4393 7.69222 5.98507 7.69222 6.55414V7.35669C7.69222 7.47641 7.64576 7.59124 7.56306 7.6759C7.48035 7.76056 7.36818 7.80812 7.25122 7.80812H3.941C3.82404 7.80812 3.71187 7.76056 3.62917 7.6759C3.54646 7.59124 3.5 7.47641 3.5 7.35669V6.55414C3.5 5.98507 3.72084 5.4393 4.11394 5.0369C4.4226 4.72093 4.81763 4.51368 5.24222 4.43923V3.87898C5.24222 3.5464 5.37128 3.22745 5.60102 2.99228C5.83075 2.75712 6.14233 2.625 6.46722 2.625H9.08056C9.40545 2.625 9.71703 2.75712 9.94676 2.99228C10.1765 3.22745 10.3056 3.5464 10.3056 3.87898V11.0127C10.3056 11.2128 10.1471 11.375 9.95167 11.375C9.75622 11.375 9.59778 11.2128 9.59778 11.0127V3.87898C9.59778 3.73856 9.54328 3.60389 9.44629 3.5046C9.34929 3.4053 9.21773 3.34952 9.08056 3.34952H6.46722ZM5.59611 5.13296C5.2279 5.13296 4.87477 5.28269 4.61441 5.54922C4.35405 5.81574 4.20778 6.17722 4.20778 6.55414V7.0836H6.98444V6.55414C6.98444 6.17722 6.83817 5.81574 6.57781 5.54922C6.31745 5.28269 5.96432 5.13296 5.59611 5.13296Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64333 8.78344C4.64333 8.58337 4.48489 8.42118 4.28945 8.42118C4.094 8.42118 3.93556 8.58337 3.93556 8.78344V9.45223C3.93556 9.6523 4.094 9.81449 4.28945 9.81449C4.48489 9.81449 4.64333 9.6523 4.64333 9.45223V8.78344Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95 8.78344C5.95 8.58337 5.79156 8.42118 5.59611 8.42118C5.40067 8.42118 5.24222 8.58337 5.24222 8.78344V10.121C5.24222 10.3211 5.40067 10.4833 5.59611 10.4833C5.79156 10.4833 5.95 10.3211 5.95 10.121V8.78344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90278 8.42118C7.09822 8.42118 7.25667 8.58337 7.25667 8.78344V9.45223C7.25667 9.6523 7.09822 9.81449 6.90278 9.81449C6.70733 9.81449 6.54889 9.6523 6.54889 9.45223V8.78344C6.54889 8.58337 6.70733 8.42118 6.90278 8.42118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShower);
export default __webpack_public_path__ + "static/media/icon-shower.0d38c3584ebf149c98bf0d3605a846db.svg";
export { ForwardRef as ReactComponent };